import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const getAllCleaner = createAsyncThunk('cleaners/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/get-all-cleaner`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCleanerByID = createAsyncThunk('cleaners/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/get-cleaner/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateContractApproval = createAsyncThunk('cleaners/update-approval', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/cleaner/acknowledge-cleaner-request/${data?.cleaner_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

//  End contract thing:-

export const endCleanerContract = createAsyncThunk('cleaner/end-contract', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/cleaner/end-cleaner-contract/${data?.cleaner_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// export const endCleanerContract = createAsyncThunk('cleaner/end-contract', async (id, { rejectWithValue }) => {
//   try {
//     const response = await axiosInstance.put(`/admin/cleaner/end-cleaner-contract/${id}`)
//     return response
//   } catch (error) {
//     return rejectWithValue(error)
//   }
// })

export const reActivateCleanerContract = createAsyncThunk('cleaner/reactive-contract', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/cleaner/reactivate-cleaner-contract/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addStrike = createAsyncThunk('cleaners/strike', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/cleaner-strike/create-cleaner-strike`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editCleaner = createAsyncThunk('cleaner/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/cleaner/update-cleaner/${data?.cleaner_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// export const deleteCleaner = createAsyncThunk('cleaners/delete', async (id, { rejectWithValue }) => {
//   try {
//     const response = await axiosInstance.delete(`/admin/cleaner/delete-cleaner/${id}`)
//     return response
//   } catch (error) {
//     return rejectWithValue(error)
//   }
// })

// End cleaner thing:-

export const deleteCleanerNew = createAsyncThunk('cleaners/delete/put', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/cleaner/delete-cleaner/${data?.cleaner_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllCleanersName = createAsyncThunk('cleaner/get-all-cleaner-names', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/get-all-cleaner-names/${data.properties_id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllInviteCleaner = createAsyncThunk('cleaner/invite-cleaner', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/invite-cleaner/${data.property_schedule_id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllCleanerNamesByRegion = createAsyncThunk('cleaner/get-all-cleaner-names-by-region', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/get-all-cleaner-names-by-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllCleanersReviews = createAsyncThunk('cleaner/review', async (data, { rejectWithValue }) => {
  const params = data?.params
  try {
    const response = await axiosInstance.get(`cleaning-review/get-cleaning-reviews-by-cleaners/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const inviteCleaner = createAsyncThunk('cleaner/invite', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`property-schedule/update-property-schedule-cleaner/${data?.id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCleanningDetails = createAsyncThunk('cleaners/cleanning/all', async (data, { rejectWithValue }) => {
  try {
    const params = data?.data
    const response = await axiosInstance.get(`/cleaning/get-upcoming-cleaning/${data.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCleanningHistoryDetails = createAsyncThunk('cleaners/cleanning/history/all', async (data, { rejectWithValue }) => {
  try {
    const params = data?.data
    const response = await axiosInstance.get(`/cleaning/get-past-cleaning/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCleanerCalendarData = createAsyncThunk('cleaners/calendar/all', async (data, { rejectWithValue }) => {
  try {
    const params = data?.data
    const response = await axiosInstance.get(`/cleaner/get-cleaner-calendar/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getDayOffDetails = createAsyncThunk('cleaners/cleanning/dayOff/all', async (data, { rejectWithValue }) => {
  try {
    const params = data?.data
    const response = await axiosInstance.get(`/cleaner-unavailability/get-day-off-cleaner-unavailability-by-cleaner-id/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllcleaningReportsCategory = createAsyncThunk('cleaners/cleaning-reports-category', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning-reports-category/get-cleaning-reports-category`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addExtraPhotos = createAsyncThunk('cleaners/cleaning/photos', async (data, { rejectWithValue }) => {
  const params = data?.data
  try {
    const response = await axiosInstance.put(`/cleaning/add-extra-photos/${data?.id}`, params)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addExtraDocument = createAsyncThunk('cleaners/cleaning/documents', async (data, { rejectWithValue }) => {
  const params = data?.data
  try {
    const response = await axiosInstance.put(`/cleaner/add-extra-documents/${data?.id}`, params)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addExtraPayment = createAsyncThunk('cleaners/cleaning/extrapayment', async (data, { rejectWithValue }) => {
  const params = data?.data
  try {
    const response = await axiosInstance.post(`/invoice/add-extra-payment/${data?.id}`, params)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const cleanerAllDetails = createAsyncThunk('cleaners/cleaner-all-details', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/cleaner-all-details/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allCleaner: [],
  getCleaner: null,
  cleanerInfo: {},
  allCleanersName: [],
  allInviteCleaner: [],
  cleanerReviews: [],
  cleanningTabInfo: [],
  historyTabInfo: [],
  cleanerCalendarData: [],
  dayOffTabInfo: [],
  cleaningReportsCategory: [],
  allCleanersNameByRegion: [],
  cleaners: null,
  error: null
}

const cleanerSlice = createSlice({
  name: 'cleaners',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCleaner.pending, (state) => {
        state.isLoading = true
        state.allCleaner = []
      })
      .addCase(getAllCleaner.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCleaner = action.payload?.data?.data
      })
      .addCase(getAllCleaner.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCleanerByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCleanerByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanerInfo = action.payload?.data?.data
      })
      .addCase(getCleanerByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateContractApproval.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateContractApproval.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateContractApproval.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(endCleanerContract.pending, (state) => {
        state.isLoading = true
      })
      .addCase(endCleanerContract.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(endCleanerContract.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(reActivateCleanerContract.pending, (state) => {
        state.isLoading = true
      })
      .addCase(reActivateCleanerContract.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(reActivateCleanerContract.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addStrike.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addStrike.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addStrike.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editCleaner.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editCleaner.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editCleaner.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      // .addCase(deleteCleaner.pending, (state) => {
      //   state.isLoading = true
      // })
      // .addCase(deleteCleaner.fulfilled, (state) => {
      //   state.isLoading = false
      // })
      // .addCase(deleteCleaner.rejected, (state, action) => {
      //   state.isLoading = false
      //   state.error = action.error.message
      // })
      .addCase(deleteCleanerNew.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteCleanerNew.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteCleanerNew.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllCleanersName.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllCleanersName.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCleanersName = action?.payload?.data?.data
      })
      .addCase(getAllCleanersName.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allCleanersName = []
      })
      .addCase(getAllInviteCleaner.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllInviteCleaner.fulfilled, (state, action) => {
        state.isLoading = false
        state.allInviteCleaner = action?.payload?.data?.data
      })
      .addCase(getAllInviteCleaner.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allInviteCleaner = []
      })
      .addCase(getAllCleanerNamesByRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllCleanerNamesByRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCleanersNameByRegion = action?.payload?.data?.data
      })
      .addCase(getAllCleanerNamesByRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allCleanersNameByRegion = []
      })
      .addCase(getAllCleanersReviews.pending, (state) => {
        state.isLoading = true
        // state.cleanerReviews = []
      })
      .addCase(getAllCleanersReviews.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanerReviews = action?.payload?.data?.data
      })
      .addCase(getAllCleanersReviews.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.cleanerReviews = []
      })
      .addCase(getCleanningDetails.pending, (state) => {
        state.isLoading = true
        state.cleanningTabInfo = []
      })
      .addCase(getCleanningDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanningTabInfo = action.payload?.data?.data
      })
      .addCase(getCleanningDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getDayOffDetails.pending, (state) => {
        state.isLoading = true
        state.dayOffTabInfo = []
      })
      .addCase(getDayOffDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.dayOffTabInfo = action.payload?.data?.data
      })
      .addCase(getDayOffDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getCleanningHistoryDetails.pending, (state) => {
        state.isLoading = true
        state.historyTabInfo = []
      })
      .addCase(getCleanningHistoryDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.historyTabInfo = action.payload?.data?.data
      })
      .addCase(getCleanningHistoryDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCleanerCalendarData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCleanerCalendarData.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanerCalendarData = action.payload?.data?.data
      })
      .addCase(getCleanerCalendarData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllcleaningReportsCategory.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllcleaningReportsCategory.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleaningReportsCategory = action.payload?.data?.data
      })
      .addCase(getAllcleaningReportsCategory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addExtraPhotos.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addExtraPhotos.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addExtraPhotos.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addExtraDocument.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addExtraDocument.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addExtraDocument.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addExtraPayment.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addExtraPayment.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addExtraPayment.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(cleanerAllDetails.pending, (state) => {
        state.isLoading = true
      })
      .addCase(cleanerAllDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanerAllDetailsList = action.payload?.data?.data
      })
      .addCase(cleanerAllDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = cleanerSlice.actions
export default cleanerSlice.reducer
